import React from 'react';
import { Navigate } from 'react-router-dom';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { SettingsViewTemplate } from '~/core/routes/settings/SettingsTemplate';
import { AssignmentStrategyForm } from '~/packages/loanProduct/ui/assignmentStrategy/assignmentStrategyForm/AssignmentStrategyForm';

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  return (
    <AssignmentStrategyForm
      organizationId={user.organizationId}
      backUrl="/settings/assignment-strategy"
      readOnly={false}
    />
  );
};

// Exports
export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/settings/assignment-strategy" />;
      }}
    >
      <SettingsViewTemplate>
        <RouteBase />
      </SettingsViewTemplate>
    </RouteErrorBoundary>
  );
};
